<template>
  <div class="form" v-if="questionsanswers != null">


    <div class="header">
     This agreement is between the Employee and Brighton Collectibles LLC (“Employer”), based on California labor laws.
    </div>
    <strong>Understanding Meal Break Rights:</strong>
    <ol>
      <li>
        First Meal Break: I understand that if I work more than 5 hours in a workday, I am entitled to an unpaid meal break of at least 30 uninterrupted minutes, starting no later than the end of the fifth hour of work. 

      </li>
    </ol>
<br>
    
    <div>Second Meal Break: I understand that if I work more than 10 hours in a workday, I am entitled to a second unpaid meal break of at least 30 uninterrupted minutes, starting no later than the end of the tenth hour of work.</div>
    <br>
    <strong>Waiver of Meal Breaks:</strong>
    <br>
    <div>
        <ol>
            <li>First Meal Break Waiver: I agree to waive Employer's obligation to provide my first meal break if my total workday will not exceed 6 hours. If my workday goes over 6 hours, Employer will provide me with the opportunity to take a meal break as described above.</li>
            <li>Second Meal Break Waiver: I agree to waive Employer's obligation to provide my second meal break on days my shift will exceed 10 hours if:
                <ul>
                    <li>My total workday will not exceed 12 hours;</li>
                    <li>I did not waive my first meal break; and</li>
                    <li>Both my Employer and I agree to waive Employer's obligation to provide the second meal break.</li>
                </ul>
            </li>
        </ol>
    </div>

    <strong>Revoking This Agreement:</strong> 
    <div>This agreement is voluntary and can be canceled at any time by notifying my Employer in writing.</div><br><br>
    
    <div :class="{error: questionsanswers[0].answer.error != null}" class="signature signature1" >
        <strong>Acknowledgment: </strong>
        <p>By signing below, I confirm that I understand my meal break rights under California law. I agree to this waiver voluntarily and without pressure. For this waiver to take effect, my supervisor must also sign below.</p>
        <div>Employee Name: <input type="text" v-model="questionsanswers[0].answer.name"></div>
        <div>Date: <input type="text" v-model="questionsanswers[0].answer.date"> </div>
        <br>
        <div>Supervisor Name: <input type="text" v-model="questionsanswers[0].answer.supervisorName"></div>
        <div>Date: <input type="text" v-model="questionsanswers[0].answer.supervisorDate"> </div>
        <br><br>
    </div>
    <div class="signature signature2" :class="{error: questionsanswers[1].answer.error != null}">
        <strong>Revocation of Meal Break Waiver</strong>
        <p>I, the undersigned Employee, cancel this agreement effective immediately.</p>
        <div>Employee Name: <input type="text" v-model="questionsanswers[1].answer.name"></div>
        <div>Date: <input type="text" v-model="questionsanswers[1].answer.date"> </div>
        <br><br>
        
    </div>
    <div class="signature signature3" :class="{error: questionsanswers[2].answer.error != null}">
        <strong>Declining this Agreement</strong>
        <p>I, the undersigned Employee, do not agree to this waiver.</p>
        <div>Employee Name: <input type="text" v-model="questionsanswers[2].answer.name"></div>
        <div>Date: <input type="text" v-model="questionsanswers[2].answer.date"> </div>
    </div>
  




    <div class="footer" >
      <button class="backToMainBtn" @click="backToFormMain">Back</button>
      <button v-if="!readOnly" @click="submitSurvey">Submit</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MealBreakWaiver',
    props: {
      msg: String,
      answers: Object,
      readOnly: Boolean
    },
    data() {
      return {
        questionsanswers: null,
        previousAnswer: null,
        hasRevoked: false
      }
    },
    methods: {
      backToFormMain() {
        console.log ("back to main")
        this.$emit('backToSurvey', '')
      },
      checkNameValue(index){
        return this.questionsanswers[index].answer.name != '' && 
               this.questionsanswers[index].answer.name != undefined && 
               this.questionsanswers[index].answer.name != null
      },
      checkDateValue(index){
        return this.questionsanswers[index].answer.date != '' && 
               this.questionsanswers[index].answer.date != undefined && 
               this.questionsanswers[index].answer.date != null
      },
      checkSupervisorName(index){
        return this.questionsanswers[index].answer.supervisorName != '' && 
               this.questionsanswers[index].answer.supervisorName != undefined && 
               this.questionsanswers[index].answer.supervisorName != null
      },
      checkSupervisorDate(index){
        return this.questionsanswers[index].answer.supervisorDate != '' && 
               this.questionsanswers[index].answer.supervisorDate != undefined && 
               this.questionsanswers[index].answer.supervisorDate != null
      },
      submitSurvey() {
        let validForm = true
        this.questionsanswers[0].answer.error = null
        this.questionsanswers[1].answer.error = null
        this.questionsanswers[2].answer.error = null

        console.log('Previous Answer',this.previousAnswer);
        console.log('Index 0 answer:', JSON.stringify(this.questionsanswers[0].answer));
        console.log('Index 1 answer:', JSON.stringify(this.questionsanswers[1].answer));
        console.log('Index 2 answer:', JSON.stringify(this.questionsanswers[2].answer));

        // Check if all fields are empty
        if(this.previousAnswer == null && !this.checkNameValue(0) && !this.checkDateValue(0) && !this.checkNameValue(2) && !this.checkDateValue(2) && !this.checkSupervisorName(0) && !this.checkSupervisorDate(0) && !this.checkNameValue(1) && !this.checkDateValue(1)) {
            this.questionsanswers[0].answer.error = true
            this.questionsanswers[2].answer.error = true
            validForm = false;
        
        }else if(this.previousAnswer == null){

            if(this.checkNameValue(0) && (!this.checkDateValue(0) || !this.checkSupervisorName(0) || !this.checkSupervisorDate(0))){
              this.questionsanswers[0].answer.error = true
              validForm = false;
            }else if(!this.checkNameValue(0) && (this.checkDateValue(0) || this.checkSupervisorName(0) || this.checkSupervisorDate(0))){
              this.questionsanswers[0].answer.error = true
              validForm = false;
            }else if(this.checkNameValue(2) && !this.checkDateValue(2)){
              this.questionsanswers[2].answer.error = true
              validForm = false;
            }else if(!this.checkNameValue(2) && this.checkDateValue(2)){
              this.questionsanswers[2].answer.error = true
              validForm = false;
            }else if(this.checkNameValue(1) || this.checkDateValue(1)){
              this.questionsanswers[1].answer.error = true
              validForm = false;
            }else if(this.checkNameValue(0) && this.checkNameValue(2)){
              this.questionsanswers[0].answer.error = true
              this.questionsanswers[2].answer.error = true
              validForm = false;
            }

        }else if(this.previousAnswer == 0){

           if(this.hasRevoked && !this.checkNameValue(2) && (this.checkNameValue(0) || this.checkDateValue(0))){
            this.questionsanswers[0].answer.error = true
            this.questionsanswers[1].answer.error = true
            this.questionsanswers[2].answer.error = true
            validForm = false;
            console.log(15);
          }else if(this.hasRevoked && !this.checkNameValue(2) && !this.checkDateValue(0) && !this.checkDateValue(0)){
            this.questionsanswers[2].answer.error = true
            validForm = false;
            console.log(16);
          }else if(this.checkNameValue(0) && (!this.checkDateValue(0) || !this.checkSupervisorName(0) || !this.checkSupervisorDate(0))){
            this.questionsanswers[0].answer.error = true
            validForm = false;
            console.log(10);
          }else if(!this.checkNameValue(0) && (this.checkDateValue(0) || this.checkSupervisorName(0) || this.checkSupervisorDate(0))){
            this.questionsanswers[0].answer.error = true
            validForm = false;
            console.log(11);
          }else if(this.checkNameValue(2) && !this.checkDateValue(2)){
            this.questionsanswers[2].answer.error = true
            validForm = false;
            console.log(12);
          }else if(!this.checkNameValue(2) && this.checkDateValue(2)){
            this.questionsanswers[2].answer.error = true
            validForm = false;
            console.log(13);
          }else if(this.checkNameValue(0) && this.checkNameValue(2)){
            this.questionsanswers[0].answer.error = true
            this.questionsanswers[2].answer.error = true
            validForm = false;
            console.log(14);
          }else if(this.hasRevoked && (!this.checkDateValue(1) || !this.checkDateValue(1))){
            this.questionsanswers[1].answer.error = true
            validForm = false;
            console.log(14);
          }
          

        }else if(this.previousAnswer == 2){

          if(this.hasRevoked && !this.checkNameValue(0) && (this.checkNameValue(2) || this.checkDateValue(2))){
            this.questionsanswers[0].answer.error = true
            this.questionsanswers[2].answer.error = true
            validForm = false;
            console.log(15);
          }else if(this.hasRevoked && !this.checkNameValue(0) && !this.checkDateValue(2) && !this.checkDateValue(2)){
            this.questionsanswers[0].answer.error = true
            validForm = false;
            console.log(16);
          }else if(this.checkNameValue(0) && (!this.checkDateValue(0) || !this.checkSupervisorName(0) || !this.checkSupervisorDate(0))){
            this.questionsanswers[0].answer.error = true
            validForm = false;
            console.log(10);
          }else if(!this.checkNameValue(0) && (this.checkDateValue(0) || this.checkSupervisorName(0) || this.checkSupervisorDate(0))){
            this.questionsanswers[0].answer.error = true
            validForm = false;
            console.log(11);
          }else if(this.checkNameValue(2) && !this.checkDateValue(2)){
            this.questionsanswers[2].answer.error = true
            validForm = false;
            console.log(12);
          }else if(!this.checkNameValue(2) && this.checkDateValue(2)){
            this.questionsanswers[2].answer.error = true
            validForm = false;
            console.log(13);
          }else if(this.checkNameValue(0) && this.checkNameValue(2)){
            this.questionsanswers[0].answer.error = true
            this.questionsanswers[2].answer.error = true
            validForm = false;
            console.log(14);
          }else if(this.hasRevoked && (!this.checkDateValue(1) || !this.checkDateValue(1))){
            this.questionsanswers[1].answer.error = true
            validForm = false;
            console.log(14);
          }
          

        }

        
        console.log('Validation result:', validForm)
        
        //validForm = false;

        if (!validForm)
          return false;
        else {
          for (let i=0; i < this.questionsanswers.length; i++) {
            if(this.questionsanswers[i].answer.name == '')
              this.questionsanswers[i].answer = ''
            delete this.questionsanswers[i].answer.error
          }
          this.$emit('submitSurvey', this.questionsanswers)

        }
      }
    },
    mounted() {
      console.log('form mealbreak waiver mounted')
      console.log(this.answers)
      // if(this.answers != null && this.answers.length > 0){
      //     this.questionsanswers = JSON.parse(JSON.stringify(this.answers))
      //     console.log('herer')
          
      // }   
      // else {
        this.questionsanswers = [
          {
            question: "By signing below, I confirm that I understand my meal break rights under California law. I agree to this waiver voluntarily and without pressure. For this waiver to take effect, my supervisor must also sign below.",
            answer: {
              name: '',
              date: "",
              error:null,
              supervisorName: '',
              supervisorDate: ""
            }
          },
          {
            question: "I, the undersigned Employee, cancel this agreement effective immediately.",
            answer: {
              name: '',
              date: "",
              error:null
            }
          },
          {
            question: "I, the undersigned Employee, do not agree to this waiver.",
            answer: {
              name: "",
              date: "",
              error:null
            }
          },
          
        ]
        if(this.answers != null && this.answers.length > 0){
            for (let i=0; i < this.answers.length; i++) {
              console.log(`Index ${i}: name = "${this.answers[i].answer.name}", length = ${this.answers[i].answer.name ? this.answers[i].answer.name.length : 0}`);
              if(this.questionsanswers[i].answer.name != undefined) {
                if(this.answers[i].answer.name != "" && this.answers[i].answer.name != undefined && i != 1){
                  this.previousAnswer = i;             
                }
                this.questionsanswers[i].answer.name = this.answers[i].answer.name
              }
              if(this.questionsanswers[i].answer.date != undefined)
                this.questionsanswers[i].answer.date = this.answers[i].answer.date
              if(this.questionsanswers[i].answer.supervisorName != undefined)
                this.questionsanswers[i].answer.supervisorName = this.answers[i].answer.supervisorName
              if(this.questionsanswers[i].answer.supervisorDate != undefined)
                this.questionsanswers[i].answer.supervisorDate = this.answers[i].answer.supervisorDate
            }

            if(this.previousAnswer != null){
              this.hasRevoked = true;
            }
        }
      // }
    },
    unmounted() {
      // Cleanup tasks after unmounting
      console.log('Component has been unmounted');
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .form{
    /* max-width:800px; */
    display:block;
    position:relative;
    margin: 0 auto;
    .header{
      display:block;
      padding-bottom:10px;
    }
    .signature{
      div{
        display: block;
        margin-left: 0;
        margin-bottom: 5px;
      }
    }
    ol{
      padding-left:35px;
      display:block;
      li {
        padding: 0 0 10px 10px;
        .q{
          /* margin-bottom:30px; */
          display:block;
        }
        .a {
          /* margin-bottom:30px; */
          display:block;

        }
        .a.error {
          border:1px solid red;
        }
      }
    }
    .footer {
      line-height: 2;
      font-weight: bold;
      padding: 20px 0 0 0;
      text-align: center;;
      button {
        display: inline-block;
        margin: 10px 5px auto;
        /* padding: 0 30px; */
      }
    }

  }

</style>
